import type { ImeiHubServiceId } from './ImeiHubSignalIcon'

const BRAND = 'reDevicer'

export function splitImeiHubServiceTitle(full: string): { brand: string; product: string } | null {
  const prefix = `${BRAND} `
  if (!full.startsWith(prefix)) return null
  const product = full.slice(prefix.length).trim()
  if (!product) return null
  return { brand: BRAND, product }
}

/** Display product name with a space for SafeCheck (e.g. "Safe Check"). */
export function formatImeiHubProductName(service: ImeiHubServiceId, product: string): string {
  if (service === 'safecheck' && product === 'SafeCheck') return 'Safe Check'
  return product
}

/** Short label for pickers and CTAs (product name only, no brand line). */
export function imeiHubServiceProductLabel(service: ImeiHubServiceId, fullTitle: string): string {
  const split = splitImeiHubServiceTitle(fullTitle)
  if (!split) return fullTitle
  return formatImeiHubProductName(service, split.product)
}

type Props = {
  service: ImeiHubServiceId
  title: string
  className?: string
  variant?: 'docs' | 'card' | 'tile' | 'report'
}

export default function ImeiHubServiceTitle({ service, title, className = '', variant = 'docs' }: Props) {
  const split = splitImeiHubServiceTitle(title)
  if (!split) {
    return <span className={className}>{title}</span>
  }

  const productLabel = formatImeiHubProductName(service, split.product)

  if (variant === 'report') {
    const label = split ? productLabel : title.trim()
    return (
      <span
        className={`vc-imei-hub-service-title vc-imei-hub-service-title--report${className ? ` ${className}` : ''}`}
      >
        <span className="vc-imei-hub-service-title__product">{label}</span>
      </span>
    )
  }

  return (
    <span
      className={`vc-imei-hub-service-title vc-imei-hub-service-title--${variant}${className ? ` ${className}` : ''}`}
    >
      <span className="vc-imei-hub-service-title__product">{productLabel}</span>
    </span>
  )
}
